// 设备录入页
import React, { useState, useEffect } from "react";
import { deviceApi, stationApi } from "@api/newApi";
import SystemApi from "@api/sys";
import { connect } from "react-redux";
import {
  Form,
  Input,
  Modal,
  Select,
  DatePicker,
  Upload,
  message,
  Spin,
  InputNumber,
  Button,
} from "antd";
import { UploadOutlined, LoadingOutlined } from "@ant-design/icons";
import { getIcons } from "@/utils/common";
import moment from "moment";
import classnames from "classnames";
import AssetImg from "../../assets/device.png";
import rightImg from "../../assets/right.png";
import download from "../../utils/download";
import "./index.scss";
const { UPLOADER, swSewagePath, BASEURL } = window.globalConfig;

const Pages = ({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [form] = Form.useForm();
  const [supplierList, setSupplierList] = useState([]);
  const [runStates, setRunStates] = useState([]);
  const [deviceBusinessTypes, setDeviceBusinessTypes] = useState([]);
  const [stationArr, setstationArr] = useState([]); // 厂站集合
  const [materielOpt, setmaterielOpt] = useState([]); // 物料类型集合
  const [processunitOpt, setprocessunitOpt] = useState([]); // 工艺单元集合
  const [deviceClassifyAll, setDeviceClassifyAll] = useState([]);
  const [mapping, setMapping] = useState({
    deviceClassifyId: {},
  });
  const [downLoading, setDownLoading] = useState(false); // 导出按钮loading状态
  const [importLoading, setImportLoading] = useState(false);

  // 获取厂站列表
  const getStationList = () => {
    stationApi
      .selectStationNameList(
        userInfo.stationIds ? userInfo.stationIds.split(",") : [],
      )
      .then((res) => {
        if (res.status * 1 === 0) {
          setstationArr(res.data);
          let id = res.data[0] ? res.data[0].id : null;
          setDefaultStation(id);
        }
      });
  };

  // 设置界面厂站初始值
  const setDefaultStation = (id) => {
    let data = {
      ...formInitVals,
      stationId: id,
    };
    setformInitVals(data);
    form.setFieldsValue(data); //设置表单的值
    changeStation(id);
  };

  useEffect(() => {
    getStationList();
    supplierAllByStation();
    selectWithClassifyKeys();
    getDeviceClassifyAll();
  }, []);

  const getDeviceClassifyAll = () => {
    SystemApi.deviceClassifyAll({}).then((res) => {
      if (res.status !== "0") return;
      const obj = {};
      res.data.forEach((item) => {
        obj[item.id] = item.classifyName;
      });
      mapping.deviceClassifyId = obj;
      setMapping({ ...mapping });
      setDeviceClassifyAll(res.data);
    });
  };

  const selectWithClassifyKeys = () => {
    SystemApi.selectWithClassifyKeys({
      classifyKeys: ["runStatuts", "deviceBusinessType"],
    }).then((res) => {
      if (res.status !== "0") return;
      const { runStatuts = [], deviceBusinessType = [] } = res.data;
      setRunStates(runStatuts);
      setDeviceBusinessTypes(deviceBusinessType);
    });
  };

  const supplierAllByStation = () => {
    SystemApi.supplierAllByStation({ stationId }).then((res) => {
      if (res.status !== "0") return;
      setSupplierList(res.data);
    });
  };

  // 切换厂站，查询物料类型、工艺单元集合和已入库设备
  const changeStation = (val) => {
    deviceApi.selectByStationId({ stationId: val }).then((res) => {
      if (res.status * 1 === 0) {
        setmaterielOpt(res.data.materiels);
        setprocessunitOpt(res.data.processunits);
      }
    });
    getDeviceData(val);
  };

  // 设备数据
  const [deviceData, setDeviceData] = useState([]);
  // 已入库设备数据是否加载中
  const [dataLoading, setDataLoading] = useState(false);

  // 查询已入库设备
  const [storageDeviceNum, setstorageDeviceNum] = useState(0); //厂站已入库设备数量
  const getDeviceData = (id) => {
    setDataLoading(true);
    deviceApi.selectStorageByStationId({ stationId: id }).then((res) => {
      setDataLoading(false);
      if (res.status * 1 === 0) {
        setstorageDeviceNum(res.data.storageDeviceNum);
        let data = res.data;
        delete data.storageDeviceNum;
        setDeviceData(data);
      }
    });
  };

  // 是否进行编辑操作
  const [isEdit, setIsEdit] = useState(false);
  // 设备点击事件
  const itemClk = (item) => {
    form.resetFields(); //重置表单
    deviceApi.getById({ deviceId: item.deviceId }).then((res) => {
      if (res.status * 1 === 0) {
        let data = {
          ...formInitVals,
          ...res.data,
          insTime: res.data.insTime ? moment(res.data.insTime) : "",
          purchaseTime: res.data.purchaseTime
            ? moment(res.data.purchaseTime)
            : "",
        };
        // 数据回填
        setformInitVals(data);
        form.setFieldsValue(data); //设置表单的值
        setIsEdit(false);
      }
    });
  };
  // 返回新增面板
  const backAddPanel = () => {
    let data = {
      id: "", //主键ID，新增不传
      stationId: formInitVals.stationId,
      deviceName: "",
      deviceModel: "",
      dossierSpec: "",
      deviceFactory: undefined,
      belongSection: "",
      insTime: "",
      purchaseTime: "",
      maintenanceCycle: 2,
      materielId: undefined,
      processunitId: undefined,
      gatherDevId: "",
      attach: "",
      updateBy: userInfo.id, //操作人ID
      updateName: userInfo.name, //操作人名称
      dutyManager: "",
      runState: undefined,
      deviceBusinessType: undefined,
      deviceClassifyId: undefined,
      installAddress: "",
      deviceNum: "",
    };
    setformInitVals(data);
    form.setFieldsValue(data);
    setIsEdit(false);
  };

  // 设备图片地址
  const [imageUrl, setImageUrl] = useState("");
  const [imgUploadLoading, setimgUploadLoading] = useState(false);
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  // 上传前进行图片限制处理
  const beforeUpload = (file) => {
    const isJpgOrPng =
      file.type === "image/jpg" ||
      file.type === "image/jpeg" ||
      file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("图片格式不正确!");
    }
    const isLt2M = file.size / 1024 / 1024 < 7;
    if (!isLt2M) {
      message.error("图片最大7M!");
    }
    return isJpgOrPng && isLt2M;
  };
  const handleChange = (info) => {
    if (info.file.status === "uploading") {
      setimgUploadLoading(true);
      return;
    }
    if (info.file.status === "done") {
      if (info.fileList[info.fileList.length - 1].response.status * 1 == 0) {
        getBase64(info.file.originFileObj, (imageUrl) => {
          setimgUploadLoading(false);
          setImageUrl(imageUrl);
        });
        let attach = info.fileList[info.fileList.length - 1].response.data.url;
        setformInitVals({
          ...formInitVals,
          attach,
        });
      }
    }
  };

  const normFile = (e) => {
    return e && e.file.response && e.file.response.data;
  };
  // 表单数据
  const [formInitVals, setformInitVals] = useState({
    id: "", //主键ID，新增不传
    stationId: "",
    deviceName: "",
    deviceModel: "",
    dossierSpec: "",
    deviceFactory: undefined,
    installAddress: "",
    insTime: "",
    maintenanceCycle: 2,
    materielId: undefined,
    processunitId: undefined,
    deviceNum: "",
    gatherDevId: "",
    attach: "",
    updateBy: userInfo.id, //操作人ID
    updateName: userInfo.name, //操作人名称
    dutyManager: "",
    runState: undefined,
    deviceBusinessType: undefined,
    deviceClassifyId: undefined,
  });

  // 工艺单元值改变，清空采集名称
  const changeProcessunitId = (val) => {
    let data = {
      ...formInitVals,
      processunitId: val,
      gatherDevId: "",
    };
    setformInitVals(data);
    form.setFieldsValue(data); //设置表单的值
  };

  // 表单项值改变事件
  const onFormLayoutChange = (data) => {
    setformInitVals({ ...formInitVals, ...data });
  };

  const [modal, modalContextHolder] = Modal.useModal();
  // 删除按钮
  const deleteBtn = () => {
    // 删除弹窗
    modal.confirm({
      content: <div>确认删除该设备？</div>,
      onOk() {
        deviceApi.deleteById({ deviceId: formInitVals.id }).then((res) => {
          if (res.status * 1 === 0) {
            message.success("删除成功。");
            backAddPanel();
            getDeviceData(formInitVals.stationId);
          }
        });
      },
    });
  };

  const [addLoading, setaddLoading] = useState(false);
  // 新增/编辑保存按钮
  const saveBtn = (values) => {
    try {
      const params = {
        ...formInitVals,
        insTime: moment(formInitVals.insTime).format("YYYY-MM-DD HH:mm:ss"),
        purchaseTime: moment(formInitVals.purchaseTime).format(
          "YYYY-MM-DD HH:mm:ss",
        ),
      };
      if (formInitVals.id == "") {
        //新增
        setaddLoading(true);
        deviceApi.create(params).then((res) => {
          setaddLoading(false);
          if (res.status * 1 === 0) {
            message.success("新增成功");
            getDeviceData(formInitVals.stationId);
            backAddPanel();
          } else {
            message.error(res.data);
          }
        });
      } else {
        deviceApi
          .update({
            ...params,
            id: formInitVals.id,
          })
          .then((res) => {
            if (res.status * 1 === 0) {
              message.success("编辑成功");
              let resData = {
                ...formInitVals,
                insTime: moment(formInitVals.insTime),
              };
              setformInitVals(resData);
              form.resetFields();
              setIsEdit(false);
              getDeviceData(data.stationId);
            } else {
              let resData = {
                ...formInitVals,
                insTime: moment(formInitVals.insTime),
              };
              setformInitVals(resData);
              message.error(res.data);
            }
          });
      }
    } catch (errorInfo) {
      console.log("Failed:", errorInfo);
    }
  };

  // 导入弹窗展示数据
  const [importModalData, setImportModalData] = useState({});
  useEffect(() => {
    // 设置导入弹窗展示数据
    stationArr.map((mm) => {
      if (mm.id === formInitVals.stationId) {
        setImportModalData(mm);
      }
    });
  }, [formInitVals.stationId]);

  // 模板下载按钮
  const downloadModule = () => {
    deviceApi
      .downloadBaImDeTemp(
        {},
        {
          responseType: "blob",
          headers: {
            "X-STATIONID": formInitVals.stationId,
            "X-UID": userInfo.id,
          },
        },
      )
      .then((res) => {
        if (res.type === "application/json") {
          const reader = new FileReader();
          reader.readAsText(res, "utf-8");
          reader.onload = () => {
            //处理报错信息 JSON.parse(reader.result)拿到报错信息
            message.error(JSON.parse(reader.result).data);
          };
        } else {
          let a = document.createElement("a");
          let blob = new Blob([res], { type: "application/vnd.ms-excel" });
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          // 获取所选厂站名称
          let stationName = "";
          stationArr.map((mm) => {
            if (formInitVals.stationId == mm.id) {
              stationName = mm.name;
            }
          });
          a.setAttribute("download", stationName + "批量导入设备模板.xls");
          a.click();
        }
      });
  };

  const downFn = () => {
    setDownLoading(true);
    SystemApi.exportDevices({ id: stationId }).then((res) => {
      setDownLoading(false);
      download(res, "设备信息.xlsx");
    });
  };

  const uploadProps = {
    name: "file",
    action: `/${BASEURL}/${swSewagePath}/api/device/importDevices`,
    headers: {
      authorization: sessionStorage.getItem("token"),
    },
    onChange(info) {
      setImportLoading(true);
      if (info.file.status === "done") {
        const { status } = info.file.response;
        setImportLoading(false);
        if (status !== "0")
          return message.error(`${info.file.name} 文件上传失败.`);
        message.success(`${info.file.name} 文件上传成功.`);
        getDeviceData(formInitVals.stationId);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} 文件上传失败.`);
      }
    },
  };

  // 导入按钮
  const importBtn = () => {
    let importM = null;
    // 导入弹窗
    importM = modal.info({
      className: "assetsAdd-page-import-modal",
      footer: null,
      centered: true,
      content: (
        <>
          <div className="import-modal-content">
            <div className="img-box">
              <img
                src={
                  importModalData.stationPic &&
                  importModalData.stationPic.split(",")[0]
                }
              />
              <i
                className="close-btn iconfont iconguanbi"
                id="closeImporMBtn"
                onClick={() => importM.destroy()}
              ></i>
            </div>
            <div className="con">
              <h6>{importModalData.name}</h6>
              <div className="btn-box">
                <div className="btn" onClick={() => downloadModule()}>
                  <i className="iconfont iconxiazaimoban"></i>
                  <span>模板下载</span>
                </div>
                <div className="btn">
                  <form id="uploadFileForm">
                    <input
                      className="file"
                      accept=".xlsx,.xls"
                      type="file"
                      name="file"
                      id="uploadFile"
                      onChange={(e) => fileChange(e)}
                    />
                    <i className="iconfont iconpiliangdaoru"></i>
                    <span>批量导入</span>
                  </form>
                </div>
              </div>
              <p>
                不同厂站模版不同，请下载对应的模版并填写！
                <span style={{ color: "red" }}>每次导入请下载最新模板！</span>
              </p>
              <div style={{ margin: "20px 0 10px 0" }}>
                <Button
                  type="dashed"
                  size="small"
                  onClick={() => importM.destroy()}
                >
                  关闭
                </Button>
              </div>
            </div>
          </div>
        </>
      ),
    });
  };

  // 上传文件改变事件
  const fileChange = (e) => {
    let name = e.target && e.target.files[0].name;
    if (name.indexOf(".xls") < 0 || name.indexOf(".xlsx") < 0) {
      message.warning("请上传xls文件或xlsx文件");
      return false;
    }
    let myForm = document.getElementById("uploadFileForm");
    let formData = new FormData(myForm);
    // 数据校验中弹窗
    const checkM = modal.info({
      className: "assetsAdd-page-check-modal",
      centered: true,
      content: (
        <>
          <Spin
            indicator={
              <LoadingOutlined
                style={{ fontSize: 40, color: "#2D99FF", fontWeight: "bolder" }}
                spin
              />
            }
          />
          <div className="txt">数据校验中请稍后</div>
        </>
      ),
    });
    deviceApi
      .dlBaImDeTempDataCheck(formData, {
        headers: {
          "Content-Type":
            "multipart/form-data; boundary=----WebKitFormBoundaryYmNa307cOmXILq7Z",
          "X-UID": userInfo.id,
          "X-STATIONID": formInitVals.stationId,
        },
        useMineErrMsg: true,
      })
      .then((res) => {
        checkM.destroy();
        if (res.status * 1 == 0) {
          let stationName = "";
          stationArr.map((mm) => {
            if (formInitVals.stationId == mm.id) {
              stationName = mm.name;
            }
          });
          // 数据校验通过弹窗
          const checkPassM = modal.info({
            className: "assetsAdd-page-checkpass-modal",
            centered: true,
            content: (
              <div className="con-box">
                <div>
                  <i className="greenok iconfont iconyanzhengtongguo"></i>
                </div>
                <h6>校验通过</h6>
                <p>
                  {/* 是否将<span>{res.data.totalDataNum}</span>条设备信息添加到 */}
                  是否将设备信息添加到
                  <strong>{stationName}</strong>中
                </p>
                <div className="btn-box">
                  <div
                    id="cancelSuccessModalBtn"
                    onClick={() => {
                      checkPassM.destroy();
                      document.getElementById("uploadFile").value = "";
                    }}
                  >
                    取消
                  </div>
                  <div onClick={() => saveImportBtn()}>保存</div>
                </div>
              </div>
            ),
          });
        } else {
          document.getElementById("uploadFile").value = "";
          if (!res.data) {
            message.error(res.message);
            return false;
          }
          let colNamelist = {
            materielName: "物料类型",
            processunitName: "工艺单元",
            deviceName: "设备名称",
            deviceModel: "设备型号",
            dossierSpec: "设备规格",
            deviceFactory: "供应商",
            insTime: "使用时间",
            maintenanceCycle: "维保周期(月)",
          };
          let tableCol = [];
          let tableData = [];
          // 组装表格数据
          res.data.checkData.map((item, idx) => {
            // 表头数据
            if (idx == 0) {
              Object.keys(item.data).map((key) => {
                tableCol.push(colNamelist[key]);
              });
            }
            // 行数据
            let row = [];
            Object.keys(item.data).map((key) => {
              row.push(item.data[key]);
            });
            row.push(item.errorData.join(","));
            tableData.push(row);
          });
          tableCol.push("错误信息");
          // 数据校验未通过弹窗
          const checkFiledM = modal.info({
            className: "assetsAdd-page-checkfiled-modal",
            centered: true,
            content: (
              <>
                <i
                  className="close-btn iconfont iconguanbi"
                  onClick={() => checkFiledM.destroy()}
                ></i>
                <div className="con-box">
                  <i className="filedred iconfont iconyanzhengshibai"></i>
                  <h6>校验未通过</h6>
                  <p className="result-tip">
                    共计<span>{res.data.totalDataNum}</span>条设备信息，其中
                    <b>{res.data.checkData.length}</b>
                    条效验未通过，请核对修改后重新上传
                  </p>
                  <div className="table-area">
                    <table>
                      <thead>
                        <tr>
                          {tableCol.map((item, idx) => {
                            return <th key={"th-" + idx}>{item}</th>;
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.map((mm, idx) => {
                          return (
                            <tr key={"tr-" + idx}>
                              {mm.map((nn, nIdx) => {
                                return (
                                  <td
                                    key={"td-" + nIdx}
                                    style={{
                                      color: nIdx == mm.length - 1 ? "red" : "",
                                    }}
                                  >
                                    {nn}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            ),
          });
        }
      });
  };
  // 导入之后，保存校验成功的数据
  const saveImportBtn = () => {
    const loadingM = modal.info({
      className: "loadingM-modal assetsAdd-page-check-modal",
      centered: true,
      content: (
        <>
          <Spin
            indicator={
              <LoadingOutlined
                style={{ fontSize: 40, color: "#2D99FF", fontWeight: "bolder" }}
                spin
              />
            }
          />
          <div className="txt">正在保存请稍后...</div>
        </>
      ),
    });
    let myForm = document.getElementById("uploadFileForm");
    let formData = new FormData(myForm);
    deviceApi
      .dlBaImDeTempDataUpload(formData, {
        headers: {
          "Content-Type":
            "multipart/form-data; boundary=----WebKitFormBoundaryYmNa307cOmXILq7Z",
          "X-UID": userInfo.id,
          "X-USERNAME": userInfo.name,
          "X-STATIONID": formInitVals.stationId,
        },
      })
      .then((res) => {
        document.getElementById("uploadFile").value = "";
        // 关闭成功弹窗
        let cancelSuccessModalBtn = document.getElementById(
          "cancelSuccessModalBtn",
        );
        cancelSuccessModalBtn.click();
        loadingM.destroy();
        if (res.status * 1 === 0) {
          // 关闭导入弹窗
          let closeImporMBtn = document.getElementById("closeImporMBtn");
          closeImporMBtn.click();
          message.success("导入成功。");
          getDeviceData(formInitVals.stationId);
        }
      });
  };

  return (
    <div className="assetsAdd-page baseContent">
      {modalContextHolder}
      <div className="side-add">
        <Spin spinning={addLoading} tip="接口请求中，请稍后..." delay={500}>
          <div className="form-tit">
            <div>
              {formInitVals.id != "" && !isEdit && (
                <img src={rightImg} onClick={() => backAddPanel()} alt="返回" />
              )}
              <span>
                {formInitVals.id == ""
                  ? "设备录入"
                  : isEdit
                    ? "设备编辑"
                    : "设备详情"}
              </span>
            </div>
            {formInitVals.deviceNum != "" && (
              <span className="tip">编码：{formInitVals.deviceNum}</span>
            )}
          </div>
          <div
            className={classnames({
              "form-box": true,
              "detail-form": formInitVals.id != "" && !isEdit,
            })}
          >
            <Form
              initialValues={formInitVals}
              labelCol={{ span: 8 }}
              layout="horizontal"
              form={form}
              onValuesChange={onFormLayoutChange}
            >
              <Form.Item label="所属厂站：">
                {formInitVals.id != "" ? (
                  formInitVals.stationName
                ) : (
                  <Form.Item name="stationId" noStyle>
                    <Select
                      style={{
                        width:
                          formInitVals.id == ""
                            ? document.body.offsetWidth > 1370
                              ? 100
                              : 100
                            : "100%",
                      }}
                      onChange={(val) => changeStation(val)}
                      placeholder="请选择"
                    >
                      {stationArr.map((item, idx) => {
                        return (
                          <Select.Option
                            value={item.id}
                            key={"stationId-" + idx}
                          >
                            {item.aliasName || item.name}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                )}
                {formInitVals.id == "" && (
                  <div className="export-btn" onClick={() => importBtn()}>
                    <i className="iconfont iconpiliangdaoru"></i>
                    <span>批量新增</span>
                  </div>
                )}
              </Form.Item>
              <Form.Item
                label="设备分类"
                {...(formInitVals.id != "" && !isEdit
                  ? {}
                  : { name: "deviceClassifyId" })}
                rules={[{ required: true, message: "必填!" }]}
              >
                {formInitVals.id != "" && !isEdit ? (
                  mapping.deviceClassifyId[formInitVals.deviceClassifyId]
                ) : (
                  <Select placeholder="请选择设备分类">
                    {deviceClassifyAll.map((item) => {
                      return (
                        <Select.Option value={item.id} key={item.id}>
                          {item.classifyName}
                        </Select.Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>
              <Form.Item
                label="设备名称"
                {...(formInitVals.id != "" && !isEdit
                  ? {}
                  : { name: "deviceName" })}
                rules={[{ required: true, message: "必填!" }]}
              >
                {formInitVals.id != "" && !isEdit ? (
                  formInitVals.deviceName
                ) : (
                  <Input
                    placeholder="请填写设备真实名称"
                    bordered={true}
                    maxLength={50}
                  />
                )}
              </Form.Item>
              <Form.Item
                label="设备型号"
                {...(formInitVals.id != "" && !isEdit
                  ? {}
                  : { name: "deviceModel" })}
                rules={[{ required: true, message: "必填!" }]}
              >
                {formInitVals.id != "" && !isEdit ? (
                  formInitVals.deviceModel
                ) : (
                  <Input placeholder="请填写设备真实型号" maxLength={50} />
                )}
              </Form.Item>
              <Form.Item
                label="设备规格"
                {...(formInitVals.id != "" && !isEdit
                  ? {}
                  : { name: "dossierSpec" })}
              >
                {formInitVals.id != "" && !isEdit ? (
                  formInitVals.dossierSpec
                ) : (
                  <Input placeholder="请填写设备真实规格" maxLength={50} />
                )}
              </Form.Item>
              <Form.Item
                label="供应商"
                {...(formInitVals.id != "" && !isEdit
                  ? {}
                  : { name: "deviceFactory" })}
                rules={[{ required: true, message: "必填!" }]}
              >
                {formInitVals.id != "" && !isEdit ? (
                  formInitVals.deviceFactory
                ) : (
                  <Select placeholder="请选择供应商">
                    {supplierList.map((item) => {
                      return (
                        <Select.Option value={item.name} key={item.id}>
                          {item.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>
              <Form.Item
                label="所属标段"
                {...(formInitVals.id != "" && !isEdit
                  ? {}
                  : { name: "belongSection" })}
                rules={[{ required: true, message: "必填!" }]}
              >
                {formInitVals.id != "" && !isEdit ? (
                  formInitVals.belongSection
                ) : (
                  <Input placeholder="请填写所属标段" maxLength={50} />
                )}
              </Form.Item>
              <Form.Item
                label="放置位置"
                {...(formInitVals.id != "" && !isEdit
                  ? {}
                  : { name: "installAddress" })}
                rules={[{ required: true, message: "必填!" }]}
              >
                {formInitVals.id != "" && !isEdit ? (
                  formInitVals.installAddress
                ) : (
                  <Input placeholder="请填写放置位置" maxLength={50} />
                )}
              </Form.Item>
              <Form.Item
                label="购置时间"
                {...(formInitVals.id != "" && !isEdit
                  ? {}
                  : { name: "purchaseTime" })}
                rules={[{ required: true, message: "必填!" }]}
              >
                {formInitVals.id != "" && !isEdit ? (
                  formInitVals.purchaseTime ? (
                    formInitVals.purchaseTime.format("YYYY-MM-DD HH:mm:ss")
                  ) : (
                    ""
                  )
                ) : (
                  <DatePicker showTime style={{ width: "100%" }} />
                )}
              </Form.Item>
              <Form.Item
                label="责任人"
                {...(formInitVals.id != "" && !isEdit
                  ? {}
                  : { name: "dutyManager" })}
                rules={[{ required: true, message: "必填!" }]}
              >
                {formInitVals.id != "" && !isEdit ? (
                  formInitVals.dutyManager
                ) : (
                  <Input placeholder="请填写责任人" maxLength={50} />
                )}
              </Form.Item>
              <Form.Item
                label="设备状态"
                {...(formInitVals.id != "" && !isEdit
                  ? {}
                  : { name: "runState" })}
                rules={[{ required: true, message: "必填!" }]}
              >
                {formInitVals.id != "" && !isEdit ? (
                  formInitVals.runState
                ) : (
                  <Select placeholder="请选择设备状态">
                    {runStates.map((item) => {
                      return (
                        <Select.Option value={item.disName} key={item.id}>
                          {item.disName}
                        </Select.Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>
              <Form.Item
                label="业务类型"
                {...(formInitVals.id != "" && !isEdit
                  ? {}
                  : { name: "deviceBusinessType" })}
                rules={[{ required: true, message: "必填!" }]}
              >
                {formInitVals.id != "" && !isEdit ? (
                  formInitVals.deviceBusinessType
                ) : (
                  <Select placeholder="请选择业务类型">
                    {deviceBusinessTypes.map((item) => {
                      return (
                        <Select.Option value={item.disName} key={item.id}>
                          {item.disName}
                        </Select.Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>

              <Form.Item
                label="投入运营时间"
                {...(formInitVals.id != "" && !isEdit
                  ? {}
                  : { name: "insTime" })}
                rules={[{ required: true, message: "必填!" }]}
              >
                {formInitVals.id != "" && !isEdit ? (
                  formInitVals.insTime ? (
                    formInitVals.insTime.format("YYYY-MM-DD HH:mm:ss")
                  ) : (
                    ""
                  )
                ) : (
                  <DatePicker showTime style={{ width: "100%" }} />
                )}
              </Form.Item>
              <Form.Item label="维保周期" style={{ position: "relative" }}>
                {formInitVals.id != "" && !isEdit ? (
                  formInitVals.maintenanceCycle + "月"
                ) : (
                  <>
                    <Form.Item
                      name="maintenanceCycle"
                      rules={[{ required: true, message: "必填!" }]}
                      noStyle
                    >
                      <InputNumber
                        placeholder="请输入"
                        type="number"
                        min={0}
                        style={{
                          width: "100%",
                          border: 0,
                          borderBottom: "1px solid #DADCE0",
                        }}
                      />
                    </Form.Item>
                    <span className="dw">月</span>
                  </>
                )}
              </Form.Item>
              <Form.Item
                label="物料类型："
                {...(formInitVals.id != "" && !isEdit
                  ? {}
                  : { name: "materielId" })}
                rules={[{ required: true, message: "必填!" }]}
              >
                {formInitVals.id != "" && !isEdit ? (
                  formInitVals.materielName
                ) : (
                  <Select placeholder="请选择">
                    {materielOpt.map((item, idx) => {
                      return (
                        <Select.Option value={item.id} key={"wl-" + idx}>
                          {item.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>
              <Form.Item
                label="工艺单元："
                {...(formInitVals.id != "" && !isEdit
                  ? {}
                  : { name: "processunitId" })}
                rules={[{ required: true, message: "必填!" }]}
              >
                {formInitVals.id != "" && !isEdit ? (
                  formInitVals.processunitName
                ) : (
                  <Select
                    placeholder="请选择"
                    onChange={(val) => changeProcessunitId(val)}
                  >
                    {processunitOpt.map((item, idx) => {
                      return (
                        <Select.Option value={item.id} key={"dy-" + idx}>
                          {item.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>
              <Form.Item
                label={formInitVals.id != "" && !isEdit ? "照片" : "上传图片："}
              >
                {formInitVals.id != "" && !isEdit ? (
                  // 详情
                  <div className="ant-upload ant-upload-select ant-upload-select-picture-card">
                    {/* <img src='https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=2742292546,3450820795&fm=26&gp=0.jpg'
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> */}
                    <img
                      src={formInitVals.attach || AssetImg}
                      alt="图片加载失败"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                ) : (
                  <>
                    <Form.Item
                      valuePropName="fileList"
                      getValueFromEvent={normFile}
                      noStyle
                    >
                      <Upload
                        headers={{
                          authorization: sessionStorage.getItem("token"),
                        }}
                        name="file"
                        listType="picture-card"
                        className="attach-uploader"
                        showUploadList={false}
                        action={UPLOADER}
                        beforeUpload={(e) => beforeUpload(e)}
                        onChange={(e) => handleChange(e)}
                      >
                        {formInitVals.attach ? (
                          <img
                            src={formInitVals.attach}
                            alt="图片加载失败"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <div className="upload-clk-area">
                            {imgUploadLoading ? (
                              <LoadingOutlined style={{ fontSize: 20 }} />
                            ) : (
                              <UploadOutlined style={{ fontSize: 20 }} />
                            )}
                            <p>{imgUploadLoading ? "上传中" : "点击上传"}</p>
                          </div>
                        )}
                      </Upload>
                    </Form.Item>
                    <p className="tip">支持jpg/png格式,小于7M</p>
                  </>
                )}
              </Form.Item>
            </Form>
          </div>
          <div className="btn-area">
            {
              // 新增
              formInitVals.id == "" && (
                <div className="save-btn btn" onClick={() => saveBtn()}>
                  <i className="iconfont iconbaocun"></i>
                  <span>保存</span>
                </div>
              )
            }
            {
              // 详情
              !isEdit && formInitVals.id != "" && (
                <>
                  <div className="btn w170" onClick={() => deleteBtn()}>
                    <i className="iconfont iconshanchu"></i>
                    <span>删除</span>
                  </div>
                  <div className="btn w170" onClick={() => setIsEdit(true)}>
                    <i className="iconfont iconbianji"></i>
                    <span>编辑</span>
                  </div>
                </>
              )
            }
            {
              // 编辑
              formInitVals.id != "" && isEdit && (
                <>
                  <div
                    className="btn w80"
                    onClick={() => {
                      setIsEdit(false);
                      form.resetFields();
                    }}
                  >
                    <i className="iconfont iconfanhui"></i>
                    <span>取消</span>
                  </div>
                  <div className="btn save-btn w256" onClick={() => saveBtn()}>
                    <i className="iconfont iconbaocun"></i>
                    <span>保存</span>
                  </div>
                </>
              )
            }
          </div>
        </Spin>
      </div>

      <div className="device-wrap">
        <div className="title">
          已入库设备（共<span>{storageDeviceNum}</span>台）
          <Button
            style={{ marginLeft: 10 }}
            type="primary"
            loading={downLoading}
            onClick={downFn}
          >
            导出
          </Button>
          <Upload {...uploadProps}>
            <Button
              style={{ marginLeft: 10 }}
              type="primary"
              icon={<UploadOutlined style={{ display: "inline-block" }} />}
              loading={importLoading}
            >
              导入
            </Button>
          </Upload>
        </div>
        <div className="content">
          <Spin spinning={dataLoading}>
            {deviceData &&
              Object.keys(deviceData).map((key) => {
                return (
                  <div className="type-items-box" key={"device-type-" + key}>
                    <div className="type-tit">
                      <i className={"iconfont " + getIcons(key)}></i>
                      {key}
                    </div>
                    <div className="items-box">
                      {deviceData[key].length == 0 && (
                        <div style={{ textIndent: "1em", color: "#999" }}>
                          - 暂无数据 -{" "}
                        </div>
                      )}
                      {deviceData[key].map((mm, idx) => {
                        return (
                          <div
                            className="item"
                            key={"cjd-" + idx}
                            onClick={() => itemClk(mm)}
                          >
                            <div className="img-box">
                              <img
                                src={mm.attach || AssetImg}
                                alt="图片加载失败"
                              />
                            </div>
                            <div className="info-box">
                              <p>设备名称：{mm.deviceName}</p>
                              <p>设备编码：{mm.deviceNum}</p>
                              <p>物料类型：{mm.materielName}</p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
          </Spin>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Pages);
